import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Vuelidate from "vuelidate";
import VueMask from "v-mask";
import vco from "v-click-outside";
import Scrollspy from "vue2-scrollspy";
import VueSweetalert2 from "vue-sweetalert2";
import store from "@/store";
import http from "@/http";
import * as tools from "@/tools";
import gmapsInit from "@/gmaps";
import DatePicker from "vue2-datepicker";
import VueTour from "vue-tour";
import money from "v-money";

import "vue2-datepicker/locale/pt-br";
import "../src/design/app.scss";

import App from "./App.vue";
import i18n from "./i18n";
import tinymce from "vue-tinymce-editor";

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import "vue-tour/dist/vue-tour.css";
import VueLottie from "vue-lottie";

import DefaultLayout from "./pages/templates/DefaultLayout.vue";
import EmptyLayout from "./pages/templates/EmptyLayout.vue";

import trackerAssist from "@openreplay/tracker-assist";
import { tracker } from "@openreplay/tracker";

import { MonitorService } from "@/services/monitoramento/monitor/monitorService";

Vue.component("default-layout", DefaultLayout);
Vue.component("empty-layout", EmptyLayout);
Vue.component("vue-lottie", VueLottie);

Vue.component("tinymce", tinymce);
Vue.component("date-picker", DatePicker);
Vue.use(VueTour);
Vue.use(vco);
Vue.use(Scrollspy);
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueMask);
Vue.use(require("vue-chartist"));
Vue.use(VueSweetalert2);
Vue.component("apexchart", VueApexCharts);
Vue.component("VueSlickCarousel", VueSlickCarousel);
Vue.use(money, { precision: 4 });

Vue.prototype.$gmaps = gmapsInit;
Vue.prototype.$http = http;
Vue.prototype.$tools = tools;

Vue.prototype.$caminhoFotoPerfil = process.env.VUE_APP_API_BASE_URL;
Vue.prototype.$iconOcorrencia =
  "https://portal-api.unicampo.coop.br/markerGoogle/";

//"https://portal-api-dev.unicampo.coop.br/fotosUsuario/"
// Vue.prototype.$caminhoFotoPerfil = "https://portal-api-hmg.unicampo.coop.br/fotosUsuario/"
// Vue.prototype.$caminhoFotoPerfil = "https://portal-api.unicampo.coop.br/fotosUsuario/"

//Vue.prototype.$eventBus = new Vue();

const obterDadosUsuarioMonitor = () => {
  const me = store.state.me || {};
  const usuario = store.state.user || {};
  const nome = [me.nm_razao, me.nome, me.name, usuario.nm_razao]
    .find(valor => typeof valor === "string" && valor.trim());
  const codigo = [
    me.sq_usuario,
    me.cd_pessoa,
    usuario.sq_usuario,
    usuario.cd_pessoa,
    usuario.id,
    typeof usuario === "string" || typeof usuario === "number" ? usuario : null
  ].find(valor => valor !== null && valor !== undefined && valor !== "");
  const nomeNormalizado = nome?.trim() || null;
  const codigoNormalizado = codigo !== undefined ? String(codigo) : null;

  return {
    identificador: nomeNormalizado
      ? codigoNormalizado
        ? `${nomeNormalizado} [${codigoNormalizado}]`
        : nomeNormalizado
      : codigoNormalizado
        ? `Usuário ${codigoNormalizado}`
        : "visitante",
    codigo: codigoNormalizado,
    nome: nomeNormalizado
  };
};

const inicializarMonitor = async () => {
  try {
    const response = await MonitorService.buscaChavesMonitor();
    const valorChave = response.chave;
    if (valorChave) {
      tracker.configure({
        projectKey: valorChave,
        ingestPoint: "https://monitor.unicampo.coop.br/ingest",
        consoleMethods: ["log", "info", "warn", "error", "debug", "assert"],
        // O padrão de 30 mensagens/s descarta o restante dos logs em rajadas.
        // Mantemos uma margem alta para que o replay reflita o console do usuário.
        consoleThrottling: 1000,
        captureExceptions: true,
        network: {
          capturePayload: true // Capture HTTP payload
        }
      });
      tracker.use(trackerAssist({}));

      let monitorIniciado = false;
      let monitorIniciando = false;
      let dadosUsuarioAtual = obterDadosUsuarioMonitor();

      const sincronizarUsuarioMonitor = () => {
        dadosUsuarioAtual = obterDadosUsuarioMonitor();

        if (monitorIniciado) {
          tracker.setUserID(dadosUsuarioAtual.identificador);

          if (dadosUsuarioAtual.nome) {
            tracker.setMetadata("nome_usuario", dadosUsuarioAtual.nome);
          }
          if (dadosUsuarioAtual.codigo) {
            tracker.setMetadata("codigo_usuario", dadosUsuarioAtual.codigo);
          }
        }
      };

      const iniciarSessaoMonitor = forceNew => {
        if (monitorIniciado || monitorIniciando) {
          return;
        }

        dadosUsuarioAtual = obterDadosUsuarioMonitor();
        monitorIniciando = true;

        tracker
          .start({
            userID: dadosUsuarioAtual.identificador,
            metadata: {
              ...(dadosUsuarioAtual.nome && {
                nome_usuario: dadosUsuarioAtual.nome
              }),
              ...(dadosUsuarioAtual.codigo && {
                codigo_usuario: dadosUsuarioAtual.codigo
              })
            },
            forceNew
          })
          .then(resultado => {
            monitorIniciando = false;

            if (resultado?.success === false) {
              console.warn(
                "[Monitor] O monitor não iniciou a sessão:",
                resultado.reason
              );
              return;
            }

            monitorIniciado = true;
            sincronizarUsuarioMonitor();
            console.info("[OpenReplay] Captura de console ativa.");
          })
          .catch(error => {
            monitorIniciando = false;
            console.warn("[Monitor] Não foi possível iniciar o monitor:", error);
          });
      };

      store.subscribe(mutation => {
        if (mutation.type === "DEFINIR_USUARIO_LOGADO") {
          if (monitorIniciado) {
            sincronizarUsuarioMonitor();
          } else {
            iniciarSessaoMonitor(true);
          }
        }

        if (mutation.type === "ATUALIZAR_DADOS_USUARIO_LOGADO") {
          sincronizarUsuarioMonitor();
        }

        if (mutation.type === "DESLOGAR_USUARIO" && monitorIniciado) {
          // O OpenReplay mantém apenas o último userID da sessão. Encerramos
          // a gravação antes de limpar o Vuex para preservar o usuário que
          // acabou de sair, sem renomear a sessão como "visitante".
          tracker.stop();
          monitorIniciado = false;
        }
      });

      http.interceptors.response.use(response => {
        const url = String(response.config?.url || "");
        const isConsultaDoUsuario = /\/?api\/(?:auth\/me|authErp\/meErp)\/?(?:\?|$)/.test(
          url
        );
        const dadosUsuario =
          response.data?.data?.me || response.data?.data || response.data;

        if (
          isConsultaDoUsuario &&
          store.state.access_token &&
          dadosUsuario &&
          typeof dadosUsuario === "object"
        ) {
          store.commit("ATUALIZAR_DADOS_USUARIO_LOGADO", dadosUsuario);
        }

        return response;
      });

      const sincronizarAoRetornar = () => {
        if (document.visibilityState === "visible") {
          sincronizarUsuarioMonitor();
        }
      };

      window.addEventListener("focus", sincronizarAoRetornar);
      document.addEventListener("visibilitychange", sincronizarAoRetornar);

      iniciarSessaoMonitor(false);
    } else {
      console.warn("[Monitor] Nenhuma chave de monitoramento retornada.");
    }
  } catch (error) {
    console.warn(
      "[Monitor] Não foi possível inicializar o monitor de sessão:",
      error
    );
  }
};

const init = async () => {
  await inicializarMonitor();

  const module = await import("./router");
  const router = await module.default;
  new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
};

init();
